import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import { Text, List, ListItem, Box } from '@paygreen/paygreen-ui';
import { actionProductModes } from '../../../utils/constants';
import { ProductsListContainer } from './GroupedProductsList.styled';

const GroupedProductsList = ({ mode, productsData, t }) => (
    <>
        <Trans
            i18nKey={
                mode === actionProductModes.delete
                    ? 'matching.grouped.deleteSentence'
                    : 'matching.grouped.matchSentence'
            }
        >
            you are about to delete
            <Text htmlTag="strong">
                {{
                    products:
                        productsData?.length +
                        ' ' +
                        t('matching.grouped.products'),
                }}
            </Text>
            are you sure
        </Trans>

        <Box marginTop="sm">
            <ProductsListContainer>
                <List listStyle="icon">
                    {productsData.map(
                        ({ productExternalReference, productName }, index) => (
                            <ListItem
                                colorTheme="secondary"
                                bulletSize="xs"
                                key={index}
                            >
                                <Text textSize="sm" colorWab="grey50">
                                    {productExternalReference}
                                    {' - '}
                                    {productName}
                                </Text>
                            </ListItem>
                        ),
                    )}
                </List>
            </ProductsListContainer>
        </Box>
    </>
);

GroupedProductsList.propTypes = {
    mode: PropTypes.string,
    productsData: PropTypes.array,
};

GroupedProductsList.defaultProps = {
    mode: 'edit',
};

export default withTranslation('common')(GroupedProductsList);
